var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { CareAppListActionFactory } from './action-factory';
var AnnouncementActions = /** @class */ (function (_super) {
    __extends(AnnouncementActions, _super);
    function AnnouncementActions() {
        return _super.call(this, "Announcements") || this;
    }
    Object.defineProperty(AnnouncementActions.prototype, "PROMPT_EDIT", {
        get: function () {
            return "[" + this.type + "][Prompt] Edit";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AnnouncementActions.prototype, "PROMPT_DELETE", {
        get: function () {
            return "[" + this.type + "][Prompt] Delete";
        },
        enumerable: true,
        configurable: true
    });
    AnnouncementActions.prototype.PromptEdit = function (payload) {
        return {
            type: this.PROMPT_EDIT,
            payload: payload
        };
    };
    AnnouncementActions.prototype.PromptDelete = function (payload) {
        return {
            type: this.PROMPT_DELETE,
            payload: payload
        };
    };
    return AnnouncementActions;
}(CareAppListActionFactory));
export var Announcements = new AnnouncementActions();
